import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parseQuery } from "../utils/query";

const useLocationQueryParams = (parseQueryOptions) => {
  const { search } = useLocation();

  return useMemo(() => parseQuery(search, parseQueryOptions), [
    parseQueryOptions,
    search,
  ]);
};

export default useLocationQueryParams;
